import React, { useContext } from 'react'
import { t } from '@insight/toolkit-utils'
import { PDPContext } from '../../context'
import { Icon } from '@insight/toolkit-react'

export default function CarrierActivationMessage() {
  const { product } = useContext(PDPContext)

  if (!product?.availableCarriers?.length) return null

  return (
    <section className="c-product-specifications__carrier-activation-message">
      <div className="ca-msg"><Icon icon="cell-tower" size="small" /><strong>{t('Activate device with a carrier')}</strong></div>
      <div>{t('Select your carrier when you add to cart. After completing your purchase, our team will assist you in activating your device.')}</div>
    </section>
  );
}
